/**
 * Opening a print form — an in-app WORKSPACE TAB. Falls back to /print
 * in a new browser tab only when the host is not mounted (e.g. a standalone
 * page without the App shell).
 */

import type { FilledSpreadsheetModel } from './spreadsheet/types'

export interface PrintWindowLanguage {
  code: string;
  name: string;
  isDefault: boolean;
}

export interface PrintWindowDescriptor {
  connectionId: string;
  tableName: string;
  instanceId: string;
  layoutNodeId: string;
  /** Pre-filled model from POST .../print — when set, PrintWindowView skips spreadsheetDesigner. */
  model?: FilledSpreadsheetModel;
  title?: string;
  /** Resolved print locale from the fill response. Absent/null on old servers. */
  locale?: string | null;
  /** Configured Languages from the fill response. Empty on old servers. */
  languages?: PrintWindowLanguage[];
}

export function buildPrintWindowUrl(d: PrintWindowDescriptor): string {
  const qs = new URLSearchParams({
    connection_id: d.connectionId,
    table_name: d.tableName,
    instance_id: d.instanceId,
    layout_node_id: d.layoutNodeId,
  });
  return `/print?${qs.toString()}`;
}

export function openPrintWindow(d: PrintWindowDescriptor): void {
  // Lazy link to the host so this utility doesn't pull in React components
  // (and to avoid an openPrintWindow <-> printWindowBus import cycle).
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { emitOpenPrintWindow } = require('./printWindowBus') as {
    emitOpenPrintWindow: (d: PrintWindowDescriptor) => boolean;
  };
  if (emitOpenPrintWindow(d)) return;
  window.open(buildPrintWindowUrl(d), '_blank', 'noopener');
}
